
import { ModelBase } from "@models/UpsertableBase";
import { SpellLimitation } from "@dndModels/misc/Limitation";
import { DataType } from "@dndModels/Types";

/**
 * 
 */
export class SpellList extends ModelBase {
  data_type: DataType = "spell_list";
  limit: SpellLimitation = new SpellLimitation();
  limit_hash: { [source_book_id: string]: SpellLimitation } = {};
  major_limits: string[] = []; 
  // These are the sb_ids of the limits that are major limits. 
  // Only one can be used at a time in character options.

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (obj.limit_hash_array) {
        for (const lha of obj.limit_hash_array) {
          this.limit_hash[lha.source_book_id] = new SpellLimitation(lha.limit);
        }
        this.major_limits = obj.major_limits ? obj.major_limits : [];
      } else {
        this.limit = obj.limit ? new SpellLimitation(obj.limit) : new SpellLimitation();
        if (!obj.limit && obj.spell_ids) {
          this.limit.spell_ids = obj.spell_ids;
        }
      }
    }
    this.loaded = true;
  }

  get limits() {
    const ids = Object.keys(this.limit_hash);
    return ids.map(o => this.limit_hash[o]);
  }

  get limit_sbids() {
    const ids = Object.keys(this.limit_hash);
    return ids;
  }

  getLimit(sb_id: string) {
    if (!this.limit_hash[sb_id]) {
      this.limit_hash[sb_id] = new SpellLimitation();
    }
    return this.limit_hash[sb_id];
  }

  setLimit(sb_id: string, limit: SpellLimitation) {
    this.limit_hash[sb_id] = limit;
  }
  
  isEmpty(except: string[] = []): boolean {
    return this.limits.length === 0 || this.limits.every(o => o.isEmpty(except));
  }

  pushSpellId(spell_id: string, sb_id: string) {
    if (!this.limit_hash[sb_id]) {
      this.limit_hash[sb_id] = new SpellLimitation();
    }
    this.limit_hash[sb_id].spell_ids.push(spell_id);
  }

  pushSpellIds(spell_ids: string[], sb_id: string) {
    if (!this.limit_hash[sb_id]) {
      this.limit_hash[sb_id] = new SpellLimitation();
    }
    this.limit_hash[sb_id].spell_ids.push(...spell_ids);
  }

  removeSpellId(spell_id: string, sb_id: string) {
    if (!this.limit_hash[sb_id]) {
      this.limit_hash[sb_id] = new SpellLimitation();
    }
    this.limit_hash[sb_id].spell_ids = this.limit_hash[sb_id].spell_ids.filter(o => o !== spell_id);
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    const limit_hash_array: any[] = [];
    const ids = Object.keys(this.limit_hash);
    for (const source_book_id of ids) {
      limit_hash_array.push({ source_book_id, limit: this.limit_hash[source_book_id].toDBObj() });
    }
    return {
      ...base_db_obj,
      limit: this.limit.toDBObj(),
      limit_hash_array,
      major_limits: this.major_limits
    };
  }

  toLight(): any {
    return this.toDBObj();
  }

  copy(copyMe: SpellList, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.limit = copyMe.limit.clone();
    const ids = Object.keys(copyMe.limit_hash);
    const hash_copy: { [source_book_id: string]: SpellLimitation } = {};
    for (const source_book_id of ids) {
      hash_copy[source_book_id] = copyMe.limit_hash[source_book_id].clone();
    }
    this.limit_hash = hash_copy;
    this.major_limits = [...copyMe.major_limits];
  }

  clone(drop_ids = false): SpellList {
    const new_obj = new SpellList();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}